import "./CalculatedDataUploadSection.css";
import LoadingButton from "./LoadingButton";

const CalculatedDataUploadSection = ({
  fileRef,
  selectedFile,
  handleFileChange,
  uploadOptions,
  setUploadOptions,
  uploadCalculatedData,
  loading
}) => {
  return (
    <>
      <div className="calculated-data-upload-section">
        <h3 className="calculated-data-upload-section__title">Results Upload</h3>
        <div className="calculated-data-upload-section__upload-area">
          <input
            type="file"
            ref={fileRef}
            onChange={handleFileChange}
            className="calculated-data-upload-section__file-input"
            accept=".xlsx,.xls"
          />
          {selectedFile && (
            <div className="calculated-data-upload-section__file-preview">
              <img src="/preview-xlsx.png" alt="Excel file" />
              <div className="calculated-data-upload-section__file-name">
                {selectedFile.name}
              </div>
            </div>
          )}
        </div>

        <div className="calculated-data-upload-section__controls">
          <div className="calculated-data-upload-section__checkboxes">
            <label className="calculated-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.supplyMap}
                onChange={(e) => setUploadOptions({
                  ...uploadOptions,
                  supplyMap: e.target.checked
                })}
              />
              Supply map
            </label>
            <label className="calculated-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.lca}
                onChange={(e) => setUploadOptions({
                  ...uploadOptions,
                  lca: e.target.checked
                })}
              />
              LCA
            </label>
            <label className="calculated-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.ecoScore}
                onChange={(e) => setUploadOptions({
                  ...uploadOptions,
                  ecoScore: e.target.checked
                })}
              />
              Eco-Score
            </label>
            <label className="calculated-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.waterConsumption}
                onChange={(e) => setUploadOptions({
                  ...uploadOptions,
                  waterConsumption: e.target.checked
                })}
              />
              Water consumption
            </label>
            <label className="calculated-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.circularity}
                onChange={(e) => setUploadOptions({
                  ...uploadOptions,
                  circularity: e.target.checked
                })}
              />
              Circularity
            </label>
            <label className="calculated-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.careAndUse}
                onChange={(e) => setUploadOptions({
                  ...uploadOptions,
                  careAndUse: e.target.checked
                })}
              />
              Care &amp; Use
            </label>
          </div>
          <LoadingButton
            color="primary"
            variant="contained"
            className="calculated-data-upload-section__upload-button"
            onClick={uploadCalculatedData}
            loading={loading}
          >
            Upload
          </LoadingButton>
        </div>
      </div>
    </>
  );
};

export default CalculatedDataUploadSection;
